/**
 * 轮播图管理API
 * 基于系统功能模块v2.0
 */
import request from '@/utils/request'

// ==================== 管理员轮播图管理接口 ====================

/**
 * 创建轮播图
 * @param {Object} data - 轮播图数据
 * @returns {Promise}
 */
export function createBanner(data) {
  return request({
    url: '/system/banners',
    method: 'post',
    data
  })
}

/**
 * 获取轮播图列表
 * @param {Object} params - 查询参数
 * @returns {Promise}
 */
export function getBanners(params = {}) {
  return request({
    url: '/system/banners',
    method: 'get',
    params
  })
}

/**
 * 获取轮播图详情
 * @param {number} bannerId - 轮播图ID
 * @returns {Promise}
 */
export function getBanner(bannerId) {
  return request({
    url: `/system/banners/${bannerId}`,
    method: 'get'
  })
}

/**
 * 更新轮播图
 * @param {number} bannerId - 轮播图ID
 * @param {Object} data - 更新数据
 * @returns {Promise}
 */
export function updateBanner(bannerId, data) {
  return request({
    url: `/system/banners/${bannerId}`,
    method: 'put',
    data
  })
}

/**
 * 删除轮播图
 * @param {number} bannerId - 轮播图ID
 * @returns {Promise}
 */
export function deleteBanner(bannerId) {
  return request({
    url: `/system/banners/${bannerId}`,
    method: 'delete'
  })
}

/**
 * 更新轮播图状态
 * @param {number} bannerId - 轮播图ID
 * @param {boolean} isActive - 是否启用
 * @returns {Promise}
 */
export function updateBannerStatus(bannerId, isActive) {
  return request({
    url: `/system/banners/${bannerId}/status`,
    method: 'put',
    data: {
      is_active: isActive
    }
  })
}

// ==================== 用户端展示接口 ====================

/**
 * 获取用户端轮播图列表
 * @returns {Promise}
 */
export function getAppBanners() {
  return request({
    url: '/system/app/banners',
    method: 'get'
  })
} 